/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const customize = {
  updateBtns: (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductSwatch', {
      name: 'Modify Product Buttons',
      enabled: true,
      apply: () => ({
        props: (props, element) => {
          const parentElement = element?.getParentElm();
          const data =
              parentElement?.getParams()?.props?.product ||
              parentElement?.getParams()?.props?.productData ||
              parentElement?.getParams()?.props?.data ||
              parentElement?.getParentElm()?.getParentElm()?.getParams()?.props?.product;

          try {
            if (data) {
              if (data?.split_product) {
                // console.log('props: ', props)
                const variantId = data.variant_id;
                const foundVariant = data.variants.filter(function(e) {
                  return e.id == variantId;
                })
                if (typeof foundVariant[0] !== 'undefined') {
                  let optionIndex = '';
                  optionIndex = data.options_with_values.findIndex(function(e) {
                    return e.name == 'fabric';
                  })

                  if (optionIndex !== '' && optionIndex > -1) {
                    const variantTitle = foundVariant[0]['title'].split(' / ');
                    const optionName = variantTitle[optionIndex];
                    
                    if (props.label && props.label == 'Fabric') {
                      for (let i = props.options.length - 1; i >= 0; i--) {
                        let option = props.options[i];
                        let optionValue = option.value;
  
                        if (optionValue !== optionName) {
                          props.options.splice(i, 1);
                        }
                      }
                    }
                    optionIndex = '';
                  }
                }
              }
            }
          } catch(error) {
            console.log(error);
          }

          return props;
        },
        afterInit (element) {
          if (element.getRootElm().querySelector('.boost-sd__popup-select-option .boost-sd__radio-input')) {
            element.getRootElm().querySelector('.boost-sd__popup-select-option .boost-sd__radio-input').click();
          }
        }
      }),
    });
  }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateBtns]);


window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat((componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductSwatchOption', {
        name: 'Change Product Swatch Option Background',
        enabled: true,
        apply: () => ({
            afterRender(element){
                if (boostSDAppConfig.swatch_settings) {
                    let optionEls = document.getElementsByClassName('boost-sd__product-swatch-option');
                    for(let i = 0; i < optionEls.length; i++){
                        let optionEl = optionEls[i];
                        let optionValue = optionEl.getElementsByTagName('input')[0].value.toLowerCase();
                        let optionLabel = optionEl.getElementsByTagName('label')[0];
                        for (const i in boostSDAppConfig.swatch_settings) {
                          var color = boostSDAppConfig.swatch_settings[i];
                          if (color.name.toLowerCase() == optionValue.toLowerCase()) {
                            if (color.imageUrl !== '') {
                              optionLabel.style.backgroundImage = `url(${color.imageUrl})`;
                            }
                          }
                        }
                    }
                }
            }
       })
    });
  //FilterOptionSwatch
  componentRegistry.useComponentPlugin('FilterOption', {
    name: 'Update filter swatch options',
        enabled: true,
        apply: () => ({
            afterRender(element){
              if (element?.getParams()?.props.option.filterOptionId === "pf_opt_color") {
                let rootEl = element.getRootElm();
                if (rootEl) {
                  let swatchOptionBtnEls = rootEl.querySelectorAll('.boost-sd__filter-option-itemwrapper .boost-sd__filter-option-listitem .boost-sd__filter-option-item-button')
                  swatchOptionBtnEls.forEach((swatchOptionBtnEl) => {
                    let title = swatchOptionBtnEl.getAttribute('title');
                    swatchOptionBtnEl.setAttribute('aria-label', title);
                  });
                }
              }
            }
        })
  })
}); 


if(boostSDAppConfig?.filterSettings) {   boostSDAppConfig.filterSettings.filterLayout = 'horizontal'; boostSDAppConfig.themeSettings.productList.productsPerPage = 36; boostSDAppConfig.themeSettings.productList.productsPerRowOnDesktop = 4; boostSDAppConfig.themeSettings.productList.productsPerRowOnMobile = 2; }
